import { render, staticRenderFns } from "./HTicaret.vue?vue&type=template&id=c85e8174&scoped=true"
import script from "./HTicaret.vue?vue&type=script&lang=js"
export * from "./HTicaret.vue?vue&type=script&lang=js"
import style0 from "./HTicaret.vue?vue&type=style&index=0&id=c85e8174&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c85e8174",
  null
  
)

export default component.exports